import { DateTime } from "luxon"

export type FormatType = "LUXON_DATE" | "LUXON_TIME" | "FLATPICKR_DATE" | "FLATPICKR_TIME" | "UTC"

export default {
  MINUTE_INCREMENT: 5,
  LUXON_DATE_FORMAT: "MMM dd, yyyy",
  LUXON_TIME_FORMAT: "h:mm a",
  FLATPICKR_DATE_FORMAT: "M d, Y",
  FLATPICKR_TIME_FORMAT: "h:i K",

  parseDT(value: string, format: FormatType, timeZone: string | undefined) : DateTime {
    const options: { zone?: string } = {}
    if (timeZone) {
      options.zone = timeZone
    }
    const method = timeZone == "UTC" ? "fromISO" : "fromFormat"
    const dt = DateTime[method](
      value,
      this[`${format}_FORMAT`],
      options,
    )

    return dt
  },

  parse(value: string, format: FormatType, timeZone: string | undefined) : Date {
    return this.parseDT(value, format, timeZone).toJSDate()
  }
}
